export default "__VITE_ASSET__DcGbIbpC__"